{
  "common": {
    "memberCenter": "Central do membro",
    "points": "Pontos",
    "level": "Nível",
    "coupons": "Cupons",
    "checkin": "Check-in diário",
    "history": "Histórico",
    "balance": "Saldo",
    "expire": "Expirar",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "loading": "Carregando...",
    "noData": "Sem dados",
    "retry": "Tentar novamente",
    "success": "Sucesso",
    "failed": "Falhou"
  },
  "points": {
    "earn": "{amount} pontos ganhos",
    "spend": "{amount} pontos gastos",
    "balance": "Saldo atual: {amount} pontos",
    "expired": "{amount} pontos expirados",
    "estimated": "Estimado (aguardando confirmação)"
  },
  "level": {
    "current": "Nível atual: {name}",
    "nextLevel": "Próximo nível: {name}",
    "progress": "{current}/{target} para o próximo nível",
    "upgraded": "Parabéns! Promovido para {name}"
  },
  "coupon": {
    "claim": "Resgatar",
    "claimed": "Resgatado",
    "expired": "Expirado",
    "used": "Usado",
    "validUntil": "Válido até {date}"
  },
  "checkin": {
    "today": "Check-in de hoje",
    "done": "Check-in feito",
    "streak": "{days} dias consecutivos",
    "reward": "+{amount} pontos"
  },
  "errors": {
    "network": "Erro de rede, tente novamente",
    "unauthorized": "Por favor, faça login",
    "serverError": "Erro do servidor, tente novamente mais tarde",
    "timeout": "Tempo esgotado"
  },
  "ui": {
    "memberCenter": {
      "loading": "Carregando...",
      "avatarAlt": "Avatar do membro",
      "pointsBalance": "Meus pontos",
      "menuLabel": "Navegação do membro",
      "menu": {
        "pointsDetail": "Histórico de pontos",
        "levelDetail": "Benefícios do nível",
        "coupons": "Meus cupons",
        "referral": "Convidar amigos",
        "checkin": "Check-in diário"
      }
    },
    "pointsDetail": {
      "title": "Histórico de pontos",
      "empty": "Sem histórico de pontos",
      "loading": "Carregando...",
      "noMore": "Sem mais registros",
      "listLabel": "Transações de pontos",
      "status": {
        "pending": "Pendente",
        "active": "Ativo",
        "used": "Usado",
        "expired": "Expirado"
      }
    },
    "levelProgress": {
      "loading": "Carregando...",
      "maxLevel": "Nível máximo atingido",
      "progressLabel": "Progresso do nível",
      "noBenefits": "Sem benefícios",
      "nextLevel": "Próximo nível: {name}",
      "benefitsTitle": "Meus benefícios"
    },
    "couponList": {
      "title": "Meus cupons",
      "tabsLabel": "Categorias de cupons",
      "listLabel": "Lista de cupons",
      "empty": "Sem cupons disponíveis",
      "freeShipping": "Frete grátis",
      "giftValue": "Presente",
      "discountValue": "{value}% de desconto",
      "type": {
        "discount": "Desconto",
        "cash": "Dinheiro",
        "shipping": "Frete",
        "gift": "Presente"
      },
      "tab": {
        "available": "Disponível",
        "used": "Usado",
        "expired": "Expirado"
      }
    },
    "referralShare": {
      "loading": "Carregando...",
      "title": "Convidar amigos",
      "shareTitle": "Convide amigos e ganhe pontos",
      "shareText": "Cadastre-se agora e receba um presente!",
      "invitedCount": "Convidados",
      "rewardPoints": "Pontos ganhos",
      "codeLabel": "Meu código de indicação",
      "linkLabel": "Link de indicação",
      "copy": "Copiar",
      "copyCode": "Copiar código",
      "share": "Compartilhar",
      "rewardHint": "Ganhe {points} pontos por amigo convidado"
    },
    "checkinCalendar": {
      "loading": "Carregando...",
      "checking": "Fazendo check-in...",
      "checkin": "Fazer check-in",
      "alreadyChecked": "Já fez check-in hoje",
      "day": "{count} dias",
      "title": "Check-in diário",
      "streak": "{days} dias consecutivos",
      "calendarLabel": "Calendário de check-in",
      "rewardsTitle": "Recompensas de sequência",
      "rewardsLabel": "Lista de recompensas",
      "weekday": {
        "sun": "Dom",
        "mon": "Seg",
        "tue": "Ter",
        "wed": "Qua",
        "thu": "Qui",
        "fri": "Sex",
        "sat": "Sáb"
      }
    }
  },
  "sdk": {
    "error": {
      "211900": "Operação falhou, tente novamente",
      "211903": "Parâmetros de requisição inválidos",
      "211909": "Faça login ou atualize sua sessão",
      "211910": "Acesso negado",
      "211911": "Membro não encontrado",
      "211912": "Conflito de identidade, contate o suporte",
      "211931": "Erro de configuração de nível",
      "211933": "Benefício de nível indisponível",
      "211951": "Saldo de pontos insuficiente",
      "211952": "Erro no livro de pontos, contate o suporte",
      "211955": "Regra de ganho de pontos não configurada",
      "211956": "Falha ao debitar pontos",
      "211957": "Pontos expirados",
      "211958": "Conflito de transação de pontos, tente novamente",
      "211971": "Cupom indisponível",
      "211973": "Cupom já resgatado",
      "211975": "Cupom expirado",
      "211976": "Cupom já usado",
      "211991": "Serviço ocupado, tente mais tarde",
      "211001": "Falha na verificação de assinatura do webhook",
      "211003": "Requisição de webhook duplicada",
      "211005": "Credencial de plataforma expirada",
      "network": "Erro de rede, verifique sua conexão",
      "timeout": "Tempo esgotado, tente novamente",
      "aborted": "Requisição cancelada",
      "parse": "Erro ao analisar resposta",
      "unauthorized": "Por favor, faça login",
      "config": "Erro de inicialização do SDK",
      "unknown": "Ocorreu um erro desconhecido"
    }
  }
}
